<template>
    <div class="NotFound">
        404 Not Found
    </div>
</template>

<script>
    export default {
        props: {
        },
    };
</script>
